import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		width: '100%',
		padding: '0',
		margin: '0 auto !important'
	}
}));
